import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'
import {unpack} from './unpack'

export const vectorImagePlugin = createPluginFromSingleComponentPlugin({
    name: 'vectorImagePlugin',
    components: new Set(['VectorImage']),
    pack,
    unpack
})
